import React from "react";

function PostCare(props) {
    return (
        <section className="w-full flex justify-center py-5 md:px-0 md:py-10">
            <div className="flex flex-col justify-center items-center w-full xl:max-w-7xl z-10">
                <div className="heading font-fredoka font-semibold xl:self-start ">
                    After your wax...
                </div>
                <div className="flex flex-col lg:flex-row justify-center items-center w-full md:gap-10">
                    <div className="pinkbox bg-[url('/public/images/pinkbox.png')] relative bg-cover bg-center  bg-no-repeat flex items-center justify-center ">
                        <div className="text-center w-full pl-2">
                            <div className="text-xl text-center mt-2 md:mt-4">
                                24 - 48 hours post wax
                            </div>

                            <div className="mt-2 mb-2">
                                Avoid excess perspiration <br /> and friction:
                            </div>

                            <div className="flex  mt-1">
                                <ul className="text-start text-sm list-disc">
                                    <li>Swimming pools</li>
                                    <li>Working out</li>
                                    <li>Saunas</li>
                                    <li>Hot tubs</li>
                                    <li>Tanning beds</li>
                                    <li>Spray tans</li>
                                    <li>Sexual activity</li>
                                    <li>Tight clothing</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="tallPinkbox bg-[url('/public/images/tallPinkbox.png')] relative bg-cover bg-center h-full bg-no-repeat flex items-center justify-center">
                        <div className="flex flex-col justify-center items-center text-center">
                            <div className="text-2xl mb-2">What to use:</div>

                            <div className="">
                                Mechanical exfoliants manually remove dead skin
                                cells. Recommended products: exfoliating gloves,
                                dry brush, scrubs.
                                <br />
                                <br />
                                Chemical exfoliants use enzymes or acids to
                                break down the dead skin cells. Recommended
                                products: bushbalm radiant reset exfoliating
                                toner pads.
                                <br />
                                <br />
                                Moisturize with a non-comedogenic product.
                                Recommended products: bushbalm oil, fur oil,
                                finipil, etc
                            </div>
                        </div>
                    </div>

                    <div className="pinkbox bg-[url('/public/images/pinkbox.png')] relative bg-cover bg-center  bg-no-repeat flex items-center justify-center ">
                        <div className="text-center">
                            <div className="text-xl text-center">
                                3 days post wax - 24 hours before your next
                                appointment
                            </div>

                            <div className="flex  mt-3 ">
                                <ul className="list-disc text-start list-none">
                                    <li>
                                        Exfoliate 3 - 4 times a week and
                                        moisturize daily
                                    </li>
                                    <br />
                                    <li>
                                        If ingrowns occur use a spot treatment
                                        or ingrown serum
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PostCare;
